import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type AlertVariant = 'info' | 'warning' | 'success' | 'destructive';

interface AlertProps {
    variant: AlertVariant;
    children: ReactNode;
    icon?: ReactNode;
    className?: string;
}

const variantStyles: Record<AlertVariant, string> = {
    info: 'border-info/20 bg-info/10 text-info',
    warning: 'border-warning/20 bg-warning-subtle text-warning-foreground',
    success: 'border-success/20 bg-success-subtle text-success',
    destructive: 'border-destructive/20 bg-destructive/10 text-destructive',
};

export function Alert({ variant, children, icon, className }: AlertProps) {
    return (
        <div
            className={cn('rounded-lg border px-4 py-3 text-sm', variantStyles[variant], className)}
        >
            {icon ? (
                <div className="flex items-start gap-2">
                    <span className="shrink-0 mt-0.5">{icon}</span>
                    <div>{children}</div>
                </div>
            ) : (
                children
            )}
        </div>
    );
}
